function scrollToReviews(event) {
    if (event) {
        event.preventDefault();
        event.stopPropagation();
    }
    
    const reviewSection = document.querySelector('#junip-review-section-custom');
    
    if (reviewSection) {
        reviewSection.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'start' 
        });
        
        if (history.pushState) {
            const newUrl = window.location.pathname + window.location.search + '#junip-review-section-custom';
            history.pushState(null, '', newUrl);
        } else {
            window.location.hash = 'junip-review-section-custom';
        }
    } else {
        console.warn('Review section #junip-review-section-custom not found');
    }
}

// The script can be included more than once per page; bind listeners only once
if (!window.reviewsScrollBound) {
    window.reviewsScrollBound = true;

    document.addEventListener('DOMContentLoaded', function() {
        if (window.location.hash === '#junip-review-section-custom') {
            setTimeout(function() {
                scrollToReviews();
            }, 100);
        }
    });

    // Keyboard support for the review badges rendered with role="button"
    document.addEventListener('keydown', function(event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        const badge = event.target.closest && event.target.closest('.reviews-badge[role="button"]');
        if (!badge) return;
        scrollToReviews(event);
    });
}
